module.exports = __webpack_public_path__ + "static/img/14.231e1e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/zh/14.png
// module id = /X4B
// module chunks = 0